import {FC} from "react"
import {SelectionRect} from "../model/SelectionRect"
import './SelectionRectOverlay.less'

interface Props {
    selectionRect: SelectionRect | null
}

export const SelectionRectOverlay: FC<Props> = ({selectionRect}) => {
    if (!selectionRect) {
        return null
    }

    const left = Math.min(selectionRect.startX, selectionRect.endX)
    const top = Math.min(selectionRect.startY, selectionRect.endY)
    const width = Math.abs(selectionRect.endX - selectionRect.startX)
    const height = Math.abs(selectionRect.endY - selectionRect.startY)

    return (
        <div
            className="selection-rect-overlay"
            style={{
                left,
                top,
                width,
                height,
            }}
        />
    )
}
